 <script src="//unpkg.com/vue/dist/vue.js"></script>
 <script src="//unpkg.com/element-ui@2.4.7/lib/index.js"></script>


<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Devoluciones</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="4">
              <b-form-group
                :label="crearLabel('Ejecutivo', 'codejecutivo', 'datosFormulario')"
                label-for="codejecutivo">
                <b-form-select :options="valEjecutivos" v-model="datosFormulario.codejecutivo" :disabled="campoBloqueado('codejecutivo', 'datosFormulario')"                          
                >
                </b-form-select>
                
                <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.codejecutivo }}
                </span>
              </b-form-group>
            </b-col>  

            <b-col sm="3">
              <b-form-group :label="crearLabel('Fecha Desde', 'fdesde', 'datosFormulario')"
                          label-for="fdesde" :horizontal="false" >
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fdesde"
                          :disabled="campoBloqueado('fdesde', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fdesde }}
                  </span>
                  </b-input-group>
              </b-form-group>    
            </b-col>

            <b-col sm="3" >  
              <b-form-group :label="crearLabel('Fecha Hasta', 'fhasta', 'datosFormulario')"
                          label-for="fhasta" :horizontal="false" >
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fhasta"
                          :disabled="campoBloqueado('fhasta', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fhasta }}
                  </span>
                  </b-input-group>
              </b-form-group>    

            </b-col>
          
          </b-row>

          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar">
                    <i class="fa fa-search"></i> Consultar
                  </b-button>
                  <!-- <b-button variant="primary" @click="descargarExcel">
                    <i class="fa fa-file-excel-o"></i> Exportar
                  </b-button> -->
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Registro de recuperos por devolver a los asegurados</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable1">
                <data-tables
                  ref="refTableData1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps1"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"                  
                >

                
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                  >
                  
                  
                  <template slot-scope="scope">
                    <div v-if="title.prop == 'SINIESTRO'">  
                        <el-button type="text" v-if="scope.row.SINIESTRO > 1" @click="buscardetalleliquidacion(scope.row.SINIESTRO, scope.row.TRATAMIENTO, scope.row.SNDBENEFICIARIO, scope.row.IDNACBENEFICIARIO ,scope.row.BENEFICIARIO)">{{scope.row.SINIESTRO}}</el-button>
                        <p v-else >{{scope.row.SINIESTRO}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>

                   

                  </el-table-column>
                  
                  
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <!-- Detalle de Liquidaciones -->
        <b-card v-if="mostrardetalleliq == true"> 
          <div slot="header">
            <strong>Detalle de Liquidaciones </strong> <strong>Siniestro Nro. {{this.datosFormulario.nrosinietro}} </strong> 
          </div>
          
          <b-row>
            <b-col lg="12">
              <div ref="refTable2">
                <data-tables
                  ref="refTableData2"
                  :data="data2"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange"
                  @select="handleSelectionChange2"
                  @select-all="selectAll"
                  >
                  
                >
                  <el-table-column
                    v-for="title in titlesDetalleLiquidacion"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                  >
                  </el-table-column>
                  <el-table-column type="selection" width="35">
                  </el-table-column>
                </data-tables>
              </div>
              
            </b-col>
          </b-row>
          <br>
          <b-row >
            <b-col sm="3" >
              <strong>Total Gastos Pesos (AB+CO+PE) sel:</strong> <span class="price-content">{{this.$numeral(datosFormulario.totgastosselpesos).format("0,0")}}</span> 
            </b-col>
            <b-col sm="3" >
              <strong>Total Gastos Moneda (AB+CO+PE) sel:</strong> <span class="price-content">{{this.$numeral(datosFormulario.totgastosselmoneda).format("0,0.00")}}</span> 
            </b-col>
            <b-col sm="3">
              <strong>Total Recuperos Pesos sel:</strong> <span class="price-content">{{this.$numeral(datosFormulario.totrecuperoselpesos).format("0,0")}}</span> 
            </b-col>  
            <b-col sm="3">
              <strong>Total Recuperos Moneda sel:</strong> <span class="price-content">{{this.$numeral(datosFormulario.totrecuperoselmoneda).format("0,0.00")}}</span> 
            </b-col>  

             
            </b-row> 
          <div>
          </div>
          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="recuperar_devolucion(datosFormulario.nrosinietro,datosCalcDevolucion.tratamiento)">
                    <i class="fa fa-calculator"></i> Calcular Devolución
                  </b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    
    <!-- Calcular Devolucion -->
    <b-modal
      size="lg"
      ok-only
      title= "Calcular Devolución" 
      cancel-title="Cancelar"
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalCalDevolucion"
      @ok="modalCalDevolucion = false"
      @cancel="modalCalDevolucion = false"
    >
      <b-row>
        <b-col lg="12">
          <b-tabs lazy>
            <b-tab title="Cálculo de Devolución">
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small">Estado del siniestro</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="desestado" size="sm" placeholder="Estado del Siniestro" class="mt-1" v-model="datosCalcDevolucion.desestado" :disabled="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Fecha estimada de configuración</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="festconfig" size="sm" placeholder="Fecha estimada de configuración" class="mt-1" v-model="datosCalcDevolucion.festconfig" :disabled="true" :formatter= "formatter" ></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Tratamiento del recupero</label>
                </b-col>
                <b-col sm="6">
                  <b-form-select :options="tratamientos" v-model="datosCalcDevolucion.tratamiento" size="sm" class="mt-1" @change="recuperar_devolucion(datosFormulario.nrosinietro,datosCalcDevolucion.tratamiento)" ></b-form-select>
                </b-col>

                
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small">Reglas</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="reglas" size="sm" placeholder="Reglas" class="mt-1" v-model="datosCalcDevolucion.reglas" :disabled="true"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small">Moneda de la póliza</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="sndmoneda" size="sm" placeholder="Moneda de la póliza" class="mt-1" v-model="datosCalcDevolucion.sndmoneda" :disabled="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Moneda de la devolución</label>
                </b-col>
                <b-col sm="6">
                  <b-form-select :options="monedasdev" v-model="datosCalcDevolucion.monedadev"  size="sm" class="mt-1"></b-form-select>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Coaseguro (%)</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="sndcoaseguro" size="sm" placeholder="Coaseguro (%)" class="mt-1" v-model="datosCalcDevolucion.sndcoaseguro" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" >Parte Cubierta (%)</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="partcubierta" size="sm" placeholder="Parte Cubierta (%)" class="mt-1" v-model="datosCalcDevolucion.partcubierta" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small" >Recepción Informe</label>
                </b-col>
                <b-col sm="6">
                  <b-input-group>
                  
                  <b-form-input id="ilqfrecepcion" size="sm" placeholder="Recepción Informe" class="mt-1" v-model="datosCalcDevolucion.ilqfrecepcion" :disabled="true"></b-form-input>
                  <b-input-group-append>
                    <b-button v-if="datosCalcDevolucion.informe != undefined" size="sm" block  variant="info" @click="buscarInformeCorreo(datosCalcDevolucion.informe)" style="color: #ffffff;" class="mt-1" v-b-tooltip.hover title="Ver Informe"> <i class="fa fa-file-pdf-o"> </i></b-button>
                    <b-button v-if="datosCalcDevolucion.correo != undefined" size="sm" block  variant="info" @click="buscarInformeCorreo(datosCalcDevolucion.correo)" style="color: #ffffff;" class="mt-1" v-b-tooltip.hover title="Ver Correo"> <i class="fa fa-envelope-o"> </i></b-button>
                  </b-input-group-append>
                </b-input-group>
                  
                  <!-- <b-form-input id="ilqfrecepcion" size="sm" placeholder="Recepción Informe" class="mt-1" v-model="datosCalcDevolucion.ilqfrecepcion" :disabled="true"></b-form-input> -->
                  <!-- <b-link href="www.google.com" target="_self" >Link</b-link> --> 

                </b-col>
                
              </b-row>
              

              <br>
              <!-- <label for="input-small">--------------------------------------------------------------------------------------------------------------------------------------------------------</label> -->

              <b-row>
                <b-col sm="6">
                  
                </b-col>
                <b-col sm="3" align="center">
                  <b><label for="input-small">Moneda póliza</label></b>
                </b-col>
                <b-col sm="3" align="center">
                  <b><label for="input-small">Pesos</label></b>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Recuperos del período</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="totrecuperoselmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="this.datosFormulario.totrecuperomoneda" style="text-align:right" ></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="totrecuperoselpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="this.datosFormulario.totrecuperopesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Gastos (AB+CO+PE) del periodo</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="totgastosselmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="this.datosFormulario.totgastosmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="totgastosselpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="this.datosFormulario.totgastospesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b><label for="input-small" class="mt-1">Monto a devolver en este proceso</label></b>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtodevmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtodevpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Monto impago total</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtoimpagomoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtoimpagomoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtoimpagopesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtoimpagopesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Total pagos al beneficiario</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="totpagosmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.totpagosmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="totpagospesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.totpagospesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Saldo actual por devolver</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="saldoactualmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.saldoactualmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="saldoactualpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.saldoactualpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b><label for="input-small" class="mt-1">Monto a devolver es menor al saldo</label></b>
                </b-col>
                <b-col sm="3" >
                  <b-form-input id="mtodevok" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevok" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtodevokpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevokpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Reliquidación devolver recuperos</label>
                </b-col>
                <b-col sm="3" >
                  <b-form-input id="reliqmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.reliqmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="reliqpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.reliqpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <br>
              <b-row>  
                <b-col lg="4">
                  <!-- <b-button size="sm" block  variant="info" @click="accionBoton('Devolver')" style="color: #ffffff;">Devolver monto propuesto</b-button> -->
                  <b-button size="sm" block  variant="info" @click="desmarcarGastos" style="color: #ffffff;">Devolver monto propuesto</b-button>
                </b-col>
                
                <b-col lg="4" class="pb-10"> 
                  <b-button size="sm" block  variant="info" @click="accionBoton('noDevolver')" style="color: #ffffff;">No Devolver</b-button> 
                  <br>
                  <div v-if="mostrarOpciones == true">
                    <b-form-group>
                      <b-form-radio-group
                        size="sm"
                        v-model="datosCalcDevolucion.opcnodevolver"
                        :options="opcnodevolver"
                      ></b-form-radio-group>
                      <b-form-input id="obsnodevolver" size="sm" placeholder="Observación No Devolver" class="mt-1" v-model="datosCalcDevolucion.obsnodevolver"></b-form-input>
                    </b-form-group>
                    <b-button size="sm" block variant="success" @click="regresar('noDevolver')" style="color: #ffffff;">Regresar</b-button> 
                  </div>
                </b-col>

                <b-col sm="4">
                  <b-button size="sm" block  variant="info" @click="accionBoton('otroMonto')" style="color: #ffffff;">Devolver otro monto</b-button>
                  <br>
                  <div v-if="opcionesOtroMonto == true">
                    
                    <b-row>
                      <b-col sm="12">
                         <b-input-group>
                          <b-form-select size="sm" :options="devMonOtroMonto" v-model="datosCalcDevolucion.devMonOtroMonto"></b-form-select>
                          <b-input-group-append>
                            <b-form-input id="devOtroMonto" size="sm" type="number" placeholder="Debe ingresar un monto" v-model="datosCalcDevolucion.devOtroMonto" style="text-align:right"></b-form-input>
                          </b-input-group-append>
                        </b-input-group>
                      </b-col>
                    </b-row>  
                    <br>
                    <b-button size="sm" block variant="success" @click="regresar('otroMonto')" style="color: #ffffff;">Regresar</b-button> 
                  </div>
                </b-col>
                </b-row> 
                <b-row> 
                <b-col sm="12">
                  <b-form-textarea
                    id="comentarioval"
                    v-model="datosCalcDevolucion.comentarioval"
                    placeholder="Comentarios para el validador"
                    rows="2"
                    max-rows="2"
                    :disabled=accActivarBtn
                  ></b-form-textarea>
                  <!-- <span style="font-size: 10px"><b>doble click para agregar comentario</b></span> -->
                </b-col>
                </b-row> 
              <br>
                <b-row> 
                  <b-col sm="6">
                    <b-button size="sm" block variant="info" @click="addComentario" style="color: #ffffff;">Agregar Comentario</b-button> 
                  </b-col>
                  <!-- <b-col sm="6" v-if="activarBtn"> -->
                  <b-col sm="6" >
                    <b-button size="sm" block variant="info" @click="insertarDatos" style="color: #ffffff;">Actualizar comentario </b-button> 
                  </b-col>
                </b-row>

            </b-tab>

            <b-tab title="Beneficiarios">
              <br>
              <b-row>
                
                <el-table 
                  ref="refTableDataBenef"
                  :data="tableData"
                  style="width: 100%"
                  border
                  max-height="400px"
                  :row-class-name="tableRowClassName">
                  
                  <el-table-column 
                    prop="SBCCODBENEF" 
                    label="Codigo" 
                    width="90"
                    align="center">
                    <template slot-scope="scope">
                        <b-form-input id="SBCCODBENEF" size="sm" type="number" @change="buscar_beneficiario(scope.row.SBCCODBENEF)" v-model="scope.row.SBCCODBENEF" style="text-align:right"></b-form-input>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    prop="SBCIDNACBENEF" 
                    label="Id. Nación"
                    width="100"
                    align="center">
                  </el-table-column>

                  <el-table-column 
                    prop="SBCNOMBENEF" 
                    label="Nombre" 
                    width="240"
                    align="left">
                  </el-table-column>

                  <el-table-column 
                    prop="SBCMONEDA" 
                    label="Mon." 
                    width="70"
                    align="center">
                    
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.SBCMONEDA" 
                      filterable
                      placeholder="Seleccione Moneda"
                      size="small"
                      >
                        <el-option
                          v-for="item in monedas"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    prop="SBCMONTO" 
                    label="Monto" 
                    width="120"
                    align="center">

                    <template slot-scope="scope">
                        <b-form-input id="SBCMONTO" size="sm" type="number"  @change="totalmonto" v-model="scope.row.SBCMONTO" style="text-align:right"></b-form-input>
                    </template>
                  </el-table-column>

                  <el-table-column 
                    prop="SBCPORCENTAJE" 
                    label=" % " 
                    width="60"
                    align="center">
                  </el-table-column>

                  <el-table-column align="center">
                    <template slot-scope="scope">
                      <el-button size="small" variant="info" @click.native.prevent="deleteRow(scope.$index, scope.row)" >Borrar</el-button>
                    </template>
                  </el-table-column>

                </el-table>
              </b-row>
              <br>
              <b-row>
              <b-col sm="4">
                 <strong >Monto Impago por Moneda</strong>
                  <el-table ref="refTableMtoImpago"
                  :data="tableDataMtoImpago"
                  style="width: 100%"
                  border
                  max-height="200px"
                  :row-class-name="tableRowClassName">

                    <el-table-column 
                      prop="SDOMONEDA" 
                      label="Mon." 
                      width="100"
                      align="center">
                    </el-table-column>
                    <el-table-column 
                      prop="SDOSALDO" 
                      label="Monto."
                      :formatter="formatter" 
                      width="120"
                      align="right">
                    </el-table-column>
                  </el-table>
              </b-col>  
              <b-col sm="2"></b-col>
              <b-col sm="3" align="right">
                <strong >Total Monto:</strong> <span class="price-content">{{this.datosFormulario.totbenef}}</span> 
              </b-col>  
              </b-row>
              <b-row>
                <b-col sm="6"> </b-col>
                <b-col sm="6" align="right"> 
                <b-button size="sm" variant="info" @click="addRow" style="color: #ffffff; margin-left: 10px;">Agregar</b-button>
                <b-button size="sm" variant="success" @click="saveAll" style="color: #ffffff; margin-left: 10px;">Guardar todo </b-button> 
                <b-button size="sm" variant="warning" @click="totalmonto" style="color: #ffffff; margin-left: 10px;">Calcular %</b-button>
                </b-col> 
              </b-row>

            </b-tab>  
          </b-tabs>

          
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title= "Validación gastos marcados" 
      cancel-title="Desmarcar gastos y devolver"
      ok-variant="warning"
      cancel-variant="success"
      ok-title="Devolver y dejarlos bloqueados"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalGastosMarcados"
      @ok="accionBoton('Devolver','S')"
      @cancel="accionBoton('Devolver','N')"
    >
    <h5>Hay gastos marcados, quedarán bloqueados para futuras devoluciones.</h5>

      

    </b-modal>


  </div>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiDevolucion from "@/components/services/apiDevolucion";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";
import XLSX from "xlsx";

export default {
  name: "RecuperosporDevolver",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
    Datepicker,
    Multiselect,
  },
  data: function () {
    return {
      selected: [],
      exportar: false,
      mostrardetalleliq: false,
      mostrarOpciones:false,
      opcionesOtroMonto:false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },

      data : [],
      data2: [],
      monedas  : [],
      tratamientos: [],
      beneficiario:"",
      idnacbeneficiario:"",
      nombeneficiario:"",
      accActivarBtn: true,
      opcnodevolver: [],
      monedasdev: [],
      data3    : [],
      tableData :[],
      tableDataMtoImpago :[],
      dataCalDevolucion: [],
      valEjecutivos: [],
      folioseleccionados: [],
      nrosinietro: "",
      devMonOtroMonto: [],
      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      valFechas: [],
      multipleSelection: [],
      modalCalDevolucion: false,
      modalGastosMarcados: false,
      nombreexcel: "Registro de recuperos por devolver a los asegurados",
      titles: [
        {
          prop: "ASEGURADO",
          label: "Asegurado",
          align: "left",
          minwidth: "220",
        },
        {
          prop: "BENEFICIARIO",
          label: "Beneficiario",
          align: "left",
          minwidth: "220",
        },
        {
          prop: "PRODUCTO",
          label: "Producto",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "POLIZA",
          label: "Póliza",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "ESTADO",
          label: "Estado",
          align: "center",
          minwidth: "80",
        },
        {
          prop: "SINIESTRO",
          label: "Siniestro",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "EJECUTIVO",
          label: "Ejecutivo",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "DEUDOR",
          label: "Deudor",
          align: "left",
          minwidth: "200",
        },
        {
          prop: "MONEDAPOL",
          label: "Mon. póliza",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "RECUMONTO",
          label: "Mto. recuperado",
          align: "right",
          minwidth: "130",
        },
        {
          prop: "RECUMONTOPESOS",
          label: "Mto. recuperado $",
          align: "right",
          minwidth: "140",
        },
        // {
        //   prop: "TIPO",
        //   label: "Tipo",
        //   align: "center",
        //   minwidth: "100",
        // },
        // {
        //   prop: "ESTADORECU",
        //   label: "Estado del recupero",
        //   align: "center",
        //   minwidth: "150",
        // },
      ],
      
      titlesDetalleLiquidacion: [
        {
          prop: "RECEPTOR",
          label: "Receptor",
          align: "left",
          minwidth: "220",
        },
        {
          prop: "MONEDA",
          label: "Moneda",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "MONTO",
          label: "Monto",
          align: "right",
          minwidth: "100",
        },
        {
          prop: "TIPOCAMBIO",
          label: "Tipo de Cambio",
          align: "center",
          minwidth: "130",
        },
        {
          prop: "LOCMONEDA",
          label: "Moneda Loc.",
          align: "center",
          minwidth: "110",
        },
        {
          prop: "MONTOPESOS",
          label: "Monto en Pesos ",
          align: "right",
          minwidth: "130",
        },
        {
          prop: "FECPAGO",
          label: "Fecha de Pago",
          align: "center",
          minwidth: "130",
        },
        {
          prop: "SERV",
          label: "Servicio",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "TIPO",
          label: "Tipo",
          align: "center",
          minwidth: "100",
        },
        
        {
          prop: "SLQOBSERVACION",
          label: "Observación",
          align: "center",
          minwidth: "150",
        },
        
        {
          prop: "BLOQUEARDEV",
          label: " ",
          align: "center",
          minwidth: "20",
        }, 

      ],

      
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Desde'){
                let elDate = new Date(row["Fecha Desde"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      datosFormulario: {
        codejecutivo: "",
        fdesde: "",
        fhasta: "",
        totseleccion: 0,
        // Gastos (AB+CO+PE) seleccionados
        totgastosselpesos: 0,
        totgastosselmoneda: 0,
        // Recuperos seleccionados
        totrecuperoselpesos:0,
        totrecuperoselmoneda:0,
        totbenef: 0,
        totgastosmoneda:""
  
      },

      seleccionados:[],
      v_seleccionablesAB:[],

      datosCalcDevolucion: {
        desestado: "",
        festconfig: "",
        reglas: "",
        sndcoaseguro: "",
        partcubierta: "",
        mtodevmoneda: "",
        mtodevpesos: "",
        mtoimpagomoneda: "",
        mtoimpagopesos: "",
        totpagosmoneda: "",
        totpagospesos: "",
        saldoactualmoneda: "",
        saldoactualpesos: "",
        mtodevok: "",
        mtodevokpesos: "",
        ilqfrecepcion: "",
        informe: "",
        correo: "",
        nrodevolucion:"",
        reliqmoneda: "",
        reliqpesos:"",
        obsnodevolver:"",
        opcnodevolver:"",
        tratamiento:"",
        comentarioval:"",
      },

      
      
      tableProps1: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 200,
        rowClassName({ row, rowIndex}) {
          
            if(row.DDE > 0){
                return 'warning-row';
            }
            else if(row.NCD > 0){
                return 'danger-row';
            }
            else{
                return 'estiloFilaTabla';
            }
        }
      },

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 200,
        rowClassName({ row, rowIndex}) {
          
            if(row.DDE > 0){
                return 'warning-row';
            }
            if(row.NCD > 0){
                return 'danger-row';
            }
            else{
                return 'estiloFilaTabla';
            }
        }
      },
      

    };
  },

  
  methods: {

    buscarInformeCorreo(p_ruta) {
      this.$session.start(); 
      window.open(p_ruta, '_blank')
      
    },

    

    totalmonto: function () {
      var total=0;
      var totdiv=0;

      for (var i = 0; i < this.tableData.length; i++) {
          total += Number(this.tableData[i].SBCMONTO);
          // console.log(total);
      }
      this.datosFormulario.totbenef = total;

      for (var key in this.tableData) {
              
          this.tableData[key]["SBCPORCENTAJE"] = parseFloat(this.tableData[key]["SBCMONTO"] / total * 100).toFixed(2);//response.data.res[0].peridnacion; 
          
        }
      // return total;
          
    },
    
    deleteRow(index, rows) {
        return apiDevolucion
          .delete_beneficiario(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.nrosinietro,
            rows.SBCCODBENEF
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Insertar",
                "Beneficiario eliminado exitosamente",
                "success"
              );
              
              this.tableData.splice(index, 1);
              totalmonto();
              
            }
            else{
              
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
    },

    saveRow(index, rows) { 
        
        return apiDevolucion
          .insert_update_beneficiario(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.nrosinietro,
            rows.SBCCODBENEF,
            rows.SBCMONEDA, 
            rows.SBCMONTO, 
            rows.SBCPORCENTAJE
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Insertar",
                "Beneficiario registrado exitosamente.",
                "success"
              );
            }
            else{
              
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
    },


    addRow:function(){
      this.existeBenefi = 0;
      this.tableData.forEach((column, index) => {

        if  (column["SBCCODBENEF"] === this.beneficiario) {
          this.existeBenefi = 1;
        }
      })
  

        if  (this.existeBenefi > 0) {
        
        let newRow  = {
              SBCMONTO:0
            };
            this.tableData = [newRow,...this.tableData];
              ++ this.addCount;
      } else {
        let newRow  = {
              SBCMONTO:0,
              SBCCODBENEF: this.beneficiario,
              SBCIDNACBENEF: this.idnacbeneficiario,
              SBCNOMBENEF: this.nombeneficiario,
              SBCPORCENTAJE: 100
            };
            this.tableData = [newRow,...this.tableData];
              ++ this.addCount;
              }

      },

      desmarcarGastos: function(){
        console.log(this.datosCalcDevolucion.tratamiento, parseFloat(this.datosFormulario.totgastosselpesos));

      
      if (this.datosCalcDevolucion.tratamiento === 'AC' && parseFloat(this.datosFormulario.totgastosselpesos) > 0 ){

        this.modalGastosMarcados = true;

      } else {
        this.accionBoton('Devolver','S');
      }


      },
     
    reg_marca_devolucion:function(p_estado, p_nrodevolucion, p_moneda, p_monto, p_subestado, p_obssubestado, p_opciongast){
      
      this.folioseleccionados.forEach((column, index) => {
         return apiDevolucion
          .reg_marca_devolucion(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            column["SINIESTRO"],
            p_nrodevolucion, 
            column["SLQFOLIO"],
            p_estado,
            this.datosCalcDevolucion.tratamiento,
            p_subestado,
            p_obssubestado,
            p_opciongast                        
          )
          .then((response) => {

            response.data = this.keysMinuscula(response.data);

            if (response.data.festado.resultado.estado != "error"){
              
              this.resdevmarc = response.data.festado.resultado.estado;

              this.buscar();
            }
            else{
              
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            
          })

          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          }
          )

          
      })

      if (this.resdevmarc != "error"){
              this.crearNotificacion("Insertar","Devolucion marcada.","success");
            };
      
      if (p_estado == 'APR' || p_estado == 'DOM') {
        this.reg_devolucion(this.nrosinietro, p_nrodevolucion, p_moneda, p_monto);
        
      }
      
      this.modalCalDevolucion = false;
      this.mostrardetalleliq = false;
      

      
    },
    
    
    reg_devolucion:function(p_siniestro, p_devolucion, p_moneda, p_monto){
         return apiDevolucion
            .reg_devolucion(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_siniestro,
            p_devolucion,
            p_moneda,
            p_monto
          )
          .then((response) => {
              
              response.data = this.keysMinuscula(response.data);

              if (response.data.festado.resultado.estado != "error"){
                this.crearNotificacion(
                  "Insertar",
                  "Devolución generada",
                  "success"
                );
              }
              else{
                
                this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
              }
            
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          })
      
    },

    addComentario:function(){
      this.accActivarBtn = false;
      this.datosCalcDevolucion.comentarioval = '';
    },

    insertarDatos:function(){
      
      const p_aviso = null; 
      const p_siniestro = Number(this.nrosinietro); 
      const p_dato = 'COMENTARIOVALDEV';
      const p_valor = this.datosCalcDevolucion.comentarioval; 
      const p_valnro = null; 
      const p_valfec = null;

      console.log(p_valor);

      if (this.datosCalcDevolucion.comentarioval != null) {

              return apiDevolucion
          .fnc_insertdatos(
                this.$session.get("mail"),
                p_aviso, 
                p_siniestro, 
                p_dato, 
                p_valor, 
                this.$session.get("usuarioInterno"),
                p_valnro, 
                p_valfec)
          .then((response) => {
              
              this.accActivarBtn = true;  
              this.crearNotificacion(
                  "Actualiza",
                  "Comentario actualizado",
                  "success"
                );
              
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          })
        
      } else {
         this.crearNotificacion(
                  "Actualiza",
                  "Debe ingresar algún comentario",
                  "error"
                );
         return;       
      }
      

     


    },
    
    obt_nrodevolucion:function(p_estado, p_subestado, p_obssubestado, p_opciongast){      
         return apiDevolucion
          .obt_nrodevolucion(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno")
          )
          .then((response) => {
            //Obtenemos el nro de devolucion
            if (response.data.args_out.devolucion != undefined){

              this.datosCalcDevolucion.nrodevolucion = response.data.args_out.devolucion;
              // console.log(p_opciongast);
              if (p_estado =='APR'){

                if (this.datosCalcDevolucion.sndmoneda == this.datosCalcDevolucion.monedadev){
                      this.reg_marca_devolucion(p_estado, this.datosCalcDevolucion.nrodevolucion, this.datosCalcDevolucion.monedadev, this.datosCalcDevolucion.mtodevmon, null, null, p_opciongast);
                } else {
                      this.reg_marca_devolucion(p_estado, this.datosCalcDevolucion.nrodevolucion, this.datosCalcDevolucion.monedadev, this.datosCalcDevolucion.mtodevpes, null, null, p_opciongast);
                }
              } 

              if (p_estado == 'DOM'){

                this.reg_marca_devolucion(p_estado, this.datosCalcDevolucion.nrodevolucion, this.datosCalcDevolucion.devMonOtroMonto, this.datosCalcDevolucion.devOtroMonto,null, null, p_opciongast);
                 
              }
              if (p_estado == 'PEN'){

                this.reg_marca_devolucion(p_estado, this.datosCalcDevolucion.nrodevolucion, null, null, p_subestado, p_obssubestado, p_opciongast);
                 
              }
              
            }
            
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          })
      
    },
    
    saveAll:function(){
     this.tableData.forEach((column, index) => {
        return apiDevolucion
          .insert_update_beneficiario(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.nrosinietro,
            column["SBCCODBENEF"],
            column["SBCMONEDA"],
            column["SBCMONTO"],
            column["SBCPORCENTAJE"]
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Insertar",
                "Beneficiario registrado exitosamente.",
                "success"
              );
            }
            else{
              
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          })

      })   
    },

    accionBoton:function(p_accion, p_opciongast){
      if (p_accion == 'noDevolver') {
        this.mostrarOpciones = true;
        this.opcionesOtroMonto = false;
        this.datosCalcDevolucion.devMonOtroMonto = null;
        this.datosCalcDevolucion.devOtroMonto = null;
        
      }
      if(p_accion == 'otroMonto') {
        this.opcionesOtroMonto = true;
        this.mostrarOpciones = false;
        this.datosCalcDevolucion.opcnodevolver = null;

      }
      
      if(p_accion == 'Devolver') {
        this.opcionesOtroMonto = false;
        this.mostrarOpciones = false;
        this.datosCalcDevolucion.opcnodevolver = null;
        this.datosCalcDevolucion.devMonOtroMonto = null;
        this.datosCalcDevolucion.devOtroMonto = null;

        if (this.datosCalcDevolucion.monedadev == undefined){
          this.crearNotificacion(
            "Devolver",
            "Debe seleccionar la moneda a devolver",
            "error");
          return false;
        }
        
        if (this.datosCalcDevolucion.mtodevpesos == 0){
          this.crearNotificacion(
            "Devolver",
            "El monto a devolver debe ser mayor a cero",
            "error");
          return false;
        }

        if (this.datosCalcDevolucion.monedadev != undefined && this.datosCalcDevolucion.mtodevpesos != 0){
          this.obt_nrodevolucion('APR', null, null, p_opciongast);
        }        
      }

    },

    regresar:function(p_accion){
      
      if (p_accion == 'noDevolver') {
        if(this.datosCalcDevolucion.opcnodevolver == undefined)
          {this.crearNotificacion(
            "No Devolver",
            "Debe seleccionar una opción",
            "error");
          return false;          }

        if (this.datosCalcDevolucion.opcnodevolver != undefined){ 
          this.mostrarOpciones = true;
          this.opcionesOtroMonto = false;
          this.datosCalcDevolucion.devMonOtroMonto = null;
          this.datosCalcDevolucion.devOtroMonto = 0;
          
          this.obt_nrodevolucion('PEN', this.datosCalcDevolucion.opcnodevolver, this.datosCalcDevolucion.obsnodevolver,null); 
          
        } 
      }

      if (p_accion == 'otroMonto') {
        
        if(this.datosCalcDevolucion.devMonOtroMonto == undefined){
          this.crearNotificacion(
            "No Devolver",
            "Debe seleccionar una moneda",
            "error");
          return false;
        }
        
        if(this.datosCalcDevolucion.devOtroMonto == undefined){
          this.crearNotificacion(
            "No Devolver",
            "Debe ingresar un monto",
            "error"
            );
          return false;}  
        
        if (this.datosCalcDevolucion.devMonOtroMonto != undefined && this.datosCalcDevolucion.devOtroMonto != undefined) {  
          this.opcionesOtroMonto = true;
          this.mostrarOpciones = false;
          this.datosCalcDevolucion.opcnodevolver = null;
          
          this.obt_nrodevolucion('DOM', null, null,null); 
          
        }

      }

    },


    

    
    getDate(date) {
      let elDate = new Date(date)
      return elDate.getDate() + '/' + (elDate.getMonth() + 1) + '/' + elDate.getFullYear();   
    },

    toggleSelection(rows,tabla) {
      if (rows) {
        rows.forEach(row => {
          tabla.$children[0].toggleRowSelection(row);
        });
      }
    },

    selectAll(rows){
       
      let v_seleccionables = rows.filter(function (el) { if (el.BLOQUEARDEV != undefined)  return el; })
      
      let v_seleccionablesAB = rows.filter(function (el) { if (el.BLOQUEARDEV == undefined && (el.SLQTIPORECUP == "A" || el.SLQRECUOPAGO == "D" || el.SERV == "BE" || el.SERV == "LI"))  return el; })



      if (this.seleccionados.length<=0 ){ 
        
        this.seleccionados = v_seleccionables;
        v_seleccionables.forEach(row => {
          this.$refs.refTableData2.$children[0].toggleRowSelection(row, false);
        })

      } else {
        this.$refs.refTableData2.$children[0].clearSelection();
        this.seleccionados=[]; 
      }

      if (this.v_seleccionablesAB.length<=0 ){ 
        
        this.v_seleccionablesAB = v_seleccionablesAB;
        v_seleccionablesAB.forEach(row => {
          this.$refs.refTableData2.$children[0].toggleRowSelection(row, false);

        })

      } else {
        this.$refs.refTableData2.$children[0].clearSelection();
        this.v_seleccionablesAB=[]; 
      }
     
      
    },

    handleSelectionChange2(selection, row) {
    
        if (row["BLOQUEARDEV"] != undefined) {
          if (row["BLOQUEARDEV"] == "*") {
            this.$refs.refTableData2.$children[0].toggleRowSelection(row, false);
            this.crearNotificacion("Calcular","Item usado en otra devolución, no se puede seleccionar","error");  
                return false;
                };
        };    

        if (row["SERV"] == "BE" || row["SERV"] == "LI"  ) {
           this.$refs.refTableData2.$children[0].toggleRowSelection(row, false);
           this.crearNotificacion("Validación","Tipo de gasto no se puede seleccionar","error");  
           return false;
        };

        if (row["SLQTIPORECUP"] == "A" || row["SLQRECUOPAGO"] == "D") {
          this.$refs.refTableData2.$children[0].toggleRowSelection(row, false);
          this.crearNotificacion("Validación","Tipo de gasto no se puede seleccionar","error");  
          return false;
        };
      
    },

    handleSelectionChange(val) {
      // debugger;
      
      
      this.multipleSelection = val;
      this.datosFormulario.totseleccion = 0;
      this.datosFormulario.totgastosselpesos = 0,
      this.datosFormulario.totrecuperoselpesos = 0,
      this.datosFormulario.totgastosselmoneda = 0,
      this.datosFormulario.totrecuperoselmoneda = 0,

      this.folioseleccionados = val;

      
      val.forEach((column, index) => {   
          if (column["BLOQUEARDEV"] == undefined) {
              if ((column["SERV"] == "AB" || column["SERV"] == "CO" || column["SERV"] == "PE") 
                   && column["SLQTIPORECUP"] != "A"){
                   this.datosFormulario.totgastosselpesos +=  column["MONTOPESOS"];
                   this.datosFormulario.totgastosselmoneda +=  column["MONTO"];
              }
          
              if (column["TIPO"] == "R" && column["SLQTIPORECUP"] == "R"){
                 this.datosFormulario.totrecuperoselpesos +=  Math.abs(column["MONTOPESOS"]);
                 this.datosFormulario.totrecuperoselmoneda += Math.abs(column["MONTO"]);
              }
              
           } 
          
      })
     
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    
    formatNumber(n) {
      n = String(n).replace(/\D/g , "");
      return n === "" ? n : Number(n).toLocaleString();
    },

    totales(param) {
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {

        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        if (index === 3 ) {
          sums[index] = '';
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (!values.every((value) => isNaN(value))) {
          sums[index] = this.$numeral(
            values.reduce((prev, curr) => {
              const value = Number(curr);

              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          ).format();
          
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    tableRowClassName({ row }) {
      if(row.marca == "1"){
            return 'danger-row';
        }
        else{
            return 'estiloFilaTabla';
        }
      
    },

    exportarExcel() {
      this.$nextTick(function () {
        var tabla = document.getElementById("tableExcel");
        var data = XLSX.utils.table_to_sheet(tabla);
        const workbook = XLSX.utils.book_new();
        const filename = "Export";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      });
    },
    
    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.label = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.label = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },

    buscar_beneficiario(p_beneficiario){
      this.$Progress.start();
      return apiDevolucion
        .buscar_beneficiario(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_beneficiario
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          this.pagina = this.paginaAnterior;
          

          if (response.data.res.length > 0) {
            for (var key in this.tableData) {
              
              if (this.tableData[key]["SBCIDNACBENEF"] == undefined) {
                this.tableData[key]["SBCIDNACBENEF"] = response.data.res[0].peridnacion; 
                this.tableData[key]["SBCNOMBENEF"] = response.data.res[0].pernombre;
              }
            }
          }
          else{
            this.tableData[0]["SBCIDNACBENEF"] = ''; 
            this.tableData[0]["SBCNOMBENEF"] = '';
          }    
            
            
          
          this.$Progress.finish();
        })


        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },


    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;
      this.activarBtn = false;
      
      
      return apiDevolucion
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          if (response.data.fechas != undefined){
            var lista_data = response.data.fechas;
            for(var i = 0; i < lista_data.length; i++){
                this.datosFormulario.fdesde = lista_data[i]["fdesde"];
                this.datosFormulario.fhasta = lista_data[i]["fhasta"];
                this.datosFormulario.codejecutivo = lista_data[i]["codejecutivo"];
            }
          }
      
          //Carga lista de ejecutivos
          if (response.data.ejecutivos != undefined){
            var tiposEjecutivos = new Array();
            var lista_tipos_ejecutivos = response.data.ejecutivos;
            for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
                var obj = new Object();
                obj.value = lista_tipos_ejecutivos[i]["codejecutivo"];
                obj.text = lista_tipos_ejecutivos[i]["des_ejecutivo"];
                tiposEjecutivos.push(obj);
            }
            this.valEjecutivos = tiposEjecutivos;
          }

          this.monedas = this.llenaArrayLista(response.data.monedas, 'codigo', 'nombre', false);
          
          
          //Carga lista de Monedas
          if (response.data.monedas != undefined){
            var tiposMoneda = new Array();
            var lista_tipos_devMonOtroMonto = response.data.monedas;
            for(var i = 0; i < lista_tipos_devMonOtroMonto.length; i++){
                var obj = new Object();
                obj.value = lista_tipos_devMonOtroMonto[i]["codigo"];
                obj.text = lista_tipos_devMonOtroMonto[i]["descripcion"];
                tiposMoneda.push(obj);
            }
            this.devMonOtroMonto = tiposMoneda;
          }

          // Carga lista de Tratamientos
          if (response.data.tratamientos != undefined){
              var tiposTratamientos = new Array();
              var lista_tipos_tratamientos = response.data.tratamientos;
              for(var i = 0; i < lista_tipos_tratamientos.length; i++){
                  var obj = new Object();
                  obj.value = lista_tipos_tratamientos[i]["codigo"];
                  obj.text = lista_tipos_tratamientos[i]["descripcion"];
                  tiposTratamientos.push(obj);
              }
              this.tratamientos = tiposTratamientos;
            }

          this.datosFormularioEstado = response.data.festado;
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.mostrardetalleliq = false;
      this.$Progress.start();
      this.data = [];
      return apiDevolucion
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.codejecutivo,
          this.datosFormulario.fdesde, 
          this.datosFormulario.fhasta,
        )
        .then((response) => {
          
          this.data = response.data.res1;
          this.pagina = this.paginaAnterior;

          // console.log(this.data);
          
          if (this.data != null) {
            this.exportar = true;
          } else {
            this.exportar = false;
          }

          this.$Progress.finish();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscardetalleliquidacion(siniestro, p_tratamiento, p_codbeneficiario, p_idnacbeneficiario, p_nombeneficiario) {
      this.$Progress.start();
      this.data2 = [];
      this.mostrardetalleliq  = false;
      return apiDevolucion
        .recuperar_liquid(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          siniestro
        )
        .then((response) => {
          
          this.data2 = response.data.res1;
          this.pagina = this.paginaAnterior;
          this.nrosinietro = siniestro;
          this.beneficiario = p_codbeneficiario;
          this.idnacbeneficiario = p_idnacbeneficiario;
          this.nombeneficiario = p_nombeneficiario;

          
          if (this.data2 != null) {
            this.exportar = true;
            this.mostrardetalleliq = true;
            this.datosFormulario.nrosinietro = siniestro;
            this.datosCalcDevolucion.tratamiento = p_tratamiento;

          } else {
            this.exportar = false;
            this.mostrardetalleliq  = false;
          }

          this.$Progress.finish();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    recuperar_beneficiario(siniestro) {
      this.$Progress.start();
      this.tableData = [];
      this.tableDataMtoImpago = [];
      return apiDevolucion
        .recuperar_beneficiario(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          siniestro
        )
        .then((response) => {
          
          this.tableData = response.data.res1;
          this.tableDataMtoImpago = response.data.mtoimpago;
          
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          this.totalmonto();
                
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    

    recuperar_devolucion(p_siniestro, p_tratamiento){
      this.activarBtn = false;
      if(this.datosFormulario.totgastosselmoneda==0 && this.datosFormulario.totrecuperoselmoneda==0)
        {this.crearNotificacion(
                "Calcular",
                "No hay items marcados. Por favor revise",
                "error"
              );
          return false;}

      apiDevolucion
          .recuperar_devolucion(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_siniestro,
            p_tratamiento,
            this.datosFormulario.totrecuperoselmoneda,
            this.datosFormulario.totrecuperoselpesos,
            this.datosFormulario.totgastosselmoneda,
            this.datosFormulario.totgastosselpesos
          )
          .then(response => {
           
            this.dataCalDevolucion = response.data.res1;  
            this.modalCalDevolucion = true;
            
            if (response.data.res1.length > 0) {
                this.mostrarOpciones = false;
                this.opcionesOtroMonto = false;
                this.datosCalcDevolucion.desestado = response.data.res1[0].SNDESTADO;
                this.datosCalcDevolucion.festconfig = this.convierteFecha(response.data.res1[0].SNDFESTCONFIG);
                this.datosCalcDevolucion.reglas = response.data.res1[0].REGLAS;
                this.datosCalcDevolucion.sndmoneda = response.data.res1[0].SNDMONEDA;
                // this.$numeral(row[column.property]).format("0,0.00")
                this.datosCalcDevolucion.sndcoaseguro = response.data.res1[0].SNDCOASEGURO;
                this.datosCalcDevolucion.partcubierta = this.$numeral(response.data.res1[0].PARTCUBIERTA).format("0,0.00");
                // this.datosCalcDevolucion.tratamiento = response.data.res1[0].TRATAMIENTO;
                this.datosCalcDevolucion.monedadev = response.data.res1[0].MONDEVOLUCION;
                this.datosCalcDevolucion.ilqfrecepcion = this.convierteFecha(response.data.res1[0].ILQFRECEPCION);
                
                this.datosCalcDevolucion.informe = response.data.res1[0].INFORME;
                this.datosCalcDevolucion.correo = response.data.res1[0].CORREO;

                // this.$numeral(row[column.property]).format("0,0.00");
                this.datosFormulario.totrecuperomoneda = this.$numeral(this.datosFormulario.totrecuperoselmoneda).format("0,0.00");
                this.datosFormulario.totrecuperopesos = this.$numeral(this.datosFormulario.totrecuperoselpesos).format("0,0");
                
                this.datosFormulario.totgastosmoneda = this.$numeral(this.datosFormulario.totgastosselmoneda).format("0,0.00");
                this.datosFormulario.totgastospesos = this.$numeral(this.datosFormulario.totgastosselpesos).format("0,0");
                
                this.datosCalcDevolucion.mtodevmoneda = this.$numeral(response.data.res1[0].MTODEVMONEDA).format("0,0.00");
                this.datosCalcDevolucion.mtodevpesos = this.$numeral(response.data.res1[0].MTODEVPESOS).format("0,0");

                this.datosCalcDevolucion.mtodevmon = response.data.res1[0].MTODEVMONEDA;
                this.datosCalcDevolucion.mtodevpes = response.data.res1[0].MTODEVPESOS;
                


                this.datosCalcDevolucion.mtoimpagomoneda = this.$numeral(response.data.res1[0].MTOIMPAGOMONEDA).format("0,0.00");
                this.datosCalcDevolucion.mtoimpagopesos = this.$numeral(response.data.res1[0].MTOIMPAGOPESOS).format("0,0");

                this.datosCalcDevolucion.totpagosmoneda = this.$numeral(response.data.res1[0].TOTPAGOSMONEDA).format("0,0.00");
                this.datosCalcDevolucion.totpagospesos = this.$numeral(response.data.res1[0].TOTPAGOSPESOS).format("0,0");

                this.datosCalcDevolucion.saldoactualmoneda = this.$numeral(response.data.res1[0].SALDOACTUALMONEDA).format("0,0.00");
                this.datosCalcDevolucion.saldoactualpesos = this.$numeral(response.data.res1[0].SALDOACTUALPESOS).format("0,0");

                this.datosCalcDevolucion.mtodevok = response.data.res1[0].MTODEVOK;
                this.datosCalcDevolucion.mtodevokpesos = response.data.res1[0].MTODEVOKPESOS;

                this.datosCalcDevolucion.reliqmoneda = this.$numeral(response.data.res1[0].RELIQMONEDA).format("0,0.00");
                this.datosCalcDevolucion.reliqpesos = this.$numeral(response.data.res1[0].RELIQPESOS).format("0,0");

                this.datosCalcDevolucion.comentarioval = response.data.res1[0].COMENTARIOVALDEV;
            
            }

            if (this.datosCalcDevolucion.partcubierta == null || this.datosCalcDevolucion.sndcoaseguro == null)
               {this.crearNotificacion(
                   "Calcular",
                   "Falta información de coaseguro/parte cubierta. Revise.",
                   "error");
                this.modalCalDevolucion = false;  
               return false;}

              //Carga lista de Tratamientos
            // if (response.data.tratamientos != undefined){
            //   var tiposTratamientos = new Array();
            //   var lista_tipos_tratamientos = response.data.tratamientos;
            //   for(var i = 0; i < lista_tipos_tratamientos.length; i++){
            //       var obj = new Object();
            //       obj.value = lista_tipos_tratamientos[i]["CODIGO"];
            //       obj.text = lista_tipos_tratamientos[i]["DESCRIPCION"];
            //       tiposTratamientos.push(obj);
            //   }
            //   this.tratamientos = tiposTratamientos;
            // }
            
            //Carga lista de Monedas Devolucion
            if (response.data.monedasdev != undefined){
              var tiposMonedasDev = new Array();
              var lista_tipos_MonedasDev = response.data.monedasdev;
              for(var i = 0; i < lista_tipos_MonedasDev.length; i++){
                  var obj = new Object();
                  obj.value = lista_tipos_MonedasDev[i]["CODIGO"];
                  obj.text = lista_tipos_MonedasDev[i]["DESCRIPCION"];
                  tiposMonedasDev.push(obj);
              }
              this.monedasdev = tiposMonedasDev;
            }

            //Carga lista de Opcion no Devolver
            if (response.data.opcnodevolver != undefined){
              var tiposOpcNoDevolver = new Array();
              var lista_tiposOpcNoDevolver = response.data.opcnodevolver;
              for(var i = 0; i < lista_tiposOpcNoDevolver.length; i++){
                  var obj = new Object();
                  obj.value = lista_tiposOpcNoDevolver[i]["CODIGO"];
                  obj.text = lista_tiposOpcNoDevolver[i]["DESCRIPCION"];
                  tiposOpcNoDevolver.push(obj);
              }
              this.opcnodevolver = tiposOpcNoDevolver;
            }

            this.datosCalcDevolucion.obsnodevolver = null;


            this.recuperar_beneficiario(p_siniestro);
            this.$Progress.finish();

          })
          .catch(error => {
            this.modalCalDevolucion = false;
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    formatter(row, column) {
      
       
       
       if (column.property == "FECPAGO" && row[column.property]) {
           return this.configurarFechaLat(
           this.convierteFecha(row[column.property])
        )
       
       }
       else if ((column.property == "RECUMONTO" || column.property == "RECUMONTOPESOS" ||
                 column.property == "MONTO" || column.property == "MONTOPESOS" ||column.property == "TIPOCAMBIO" ||
                 column.property == "SDOSALDO" ) && row[column.property]){
          if (row[column.property] == 0 || row[column.property] == "0") {
            return row[column.property];
          } else {
            return this.$numeral(row[column.property]).format("0,0.00");
          }

       }
      else {
        return row[column.property];
      }


      
    },

    
    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },
    
    
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

   

    data2: function() {
      this.datosFormulario.totgastosselpesos = 0,
      this.datosFormulario.totrecuperoselpesos = 0,
      this.datosFormulario.totgastosselmoneda = 0,
      this.datosFormulario.totrecuperoselmoneda = 0,
      this.$nextTick(function() {
        if (this.data2.length>0){
          
          this.$refs.refTableData2.$children[0].clearSelection();
          var lista = this.data2;
          // map, filter --- para filtrar lista
          var index = 0;
          for (index = 0; index < lista.length; ++index) {
            
              if (lista[index]["CALCULARDEV"] == "s" && lista[index]["BLOQUEARDEV"] != "*" && lista[index]["DDE"] == 0 && lista[index]["NCD"] == 0){
                this.toggleSelection([lista[index]], this.$refs.refTableData2);
              }

          }
        }
        
      })
    },
  }
};

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}

@import url("//unpkg.com/element-ui@2.4.7/lib/theme-chalk/index.css");

.el-table__row .el-input .el-input__inner{
  border-style:none;
}
.hover-row .el-input .el-input__inner{
  border-style:solid;   
}
.warning-row {
    background-color: #FFFFE0!important;
    color: black!important;
  }
.danger-row {
    background-color:   #cf141412!important;
    color: black!important;
}

</style>
